export const getRoute = (route: string): string => {
    // we use a hash router for web and desktop so local routes need "#" in front of them
    return '#' + route;
};
